/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

const drawerWidth = 240;

const styles = (theme) => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    width: 'calc(100% -  14px)',
    marginRight: 14,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    marginRight: 14,
    width: `calc(100% - ${drawerWidth + 14}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
});

const mainBar = ({
  classes,
  isOpen,
  location,
  onLogin,
  toggleDrawer,
  ...other
}) => {
  let pathName =
    location.pathname.charAt(1).toUpperCase() +
    location.pathname.substr(2, location.pathname.length);

  const pathNames = pathName.split('/');
  if (pathNames[0] === 'Projects') pathNames[0] = 'Projekte';
  pathName = (
    <>
      {pathNames[0]}{' '}
      {pathNames[1] && <small style={{ opacity: 0.4 }}>/ {pathNames[1]}</small>}
    </>
  );

  return (
    <AppBar
      position='absolute'
      className={classNames(classes.appBar, isOpen && classes.appBarShift)}
    >
      <Toolbar disableGutters={!isOpen} className={classes.toolbar}>
        <IconButton
          color='inherit'
          aria-label='Open drawer'
          onClick={toggleDrawer}
          className={classNames(
            classes.menuButton,
            isOpen && classes.menuButtonHidden,
          )}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant='h6'
          color='inherit'
          noWrap
          className={classes.title}
        >
          {location.pathname.length > 1 ? pathName : 'Startseite'}
        </Typography>
        <Button color='inherit' onClick={() => onLogin(false, '', {})}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

const MainBar = withRouter(mainBar);

MainBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainBar);
